module.exports = __webpack_public_path__ + "assets/HKNova-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Regular.woff2
// module id = 108
// module chunks = 0